export default function SEOArticleSpecialization() {
  return (
    <section id="seo-specialization" className="py-12 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-8 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-focus-3-line text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Ваша ниша — наш фокус
            </span>
          </div>
          <h2 className="text-2xl sm:text-4xl md:text-5xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Специализация под вашу нишу
          </h2>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full"></div>
        </div>

        <div className="grid md:grid-cols-2 gap-5 sm:gap-8">
          {/* Card 1 */}
          <div className="bg-[#F8F9FA] rounded-2xl sm:rounded-3xl p-6 sm:p-10 border border-[#C5A880]/20 hover:border-[#C5A880]/50 transition-all duration-300">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#C5A880] rounded-full flex items-center justify-center mb-5">
              <i className="ri-user-star-line text-xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-[#1A2B4C] mb-2 font-['Playfair_Display']">
              Для экспертов и консалтинга
            </h3>
            <p className="text-sm text-gray-500 italic font-['Montserrat'] mb-4">
              Эксперт, Мастер-тренер, Специалист
            </p>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed font-['Montserrat'] text-justify">
              Формируем статус лидера, разбираем сложные кейсы и мягко продаем вашу методологию. Читатель знакомится с вами через статью — и приходит уже «тёплым», готовым к сотрудничеству.
            </p>

            <div className="mt-5 space-y-3">
              {[
                { icon: 'ri-trophy-line', text: 'Кейсы и разборы экспертных ситуаций' },
                { icon: 'ri-heart-line', text: 'Мягкие продажи через пользу и доверие' },
                { icon: 'ri-user-follow-line', text: 'Формирование личного бренда в поиске' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-[#C5A880] text-lg`}></i>
                  </div>
                  <span className="text-sm text-gray-700 font-['Montserrat']">{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-[#F8F9FA] rounded-2xl sm:rounded-3xl p-6 sm:p-10 border border-[#C5A880]/20 hover:border-[#C5A880]/50 transition-all duration-300">
            <div className="w-12 h-12 sm:w-16 sm:h-16 bg-[#1A2B4C] rounded-full flex items-center justify-center mb-5">
              <i className="ri-shopping-bag-3-line text-xl sm:text-3xl text-white"></i>
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-[#1A2B4C] mb-2 font-['Playfair_Display']">
              Для готовых товаров (E-commerce)
            </h3>
            <p className="text-sm text-gray-500 italic font-['Montserrat'] mb-4">
              Красота и Здоровье, Электроника, Детские товары, Спорт и Отдых и другие товары
            </p>
            <p className="text-sm sm:text-base text-gray-700 leading-relaxed font-['Montserrat'] text-justify">
              Создаем экспертные обзоры и гайды, которые помогают клиенту выбрать именно ваш товар. Статья отвечает на вопрос «что лучше выбрать» — и ведёт прямо к кнопке «Купить».
            </p>

            <div className="mt-5 space-y-3">
              {[
                { icon: 'ri-search-2-line', text: 'Обзоры и сравнительные гайды по товарам' },
                { icon: 'ri-links-line', text: 'Перелинковка статей с карточками товаров' },
                { icon: 'ri-star-line', text: 'Рост доверия через экспертный контент' },
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-[#C5A880] text-lg`}></i>
                  </div>
                  <span className="text-sm text-gray-700 font-['Montserrat']">{item.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
